import React from 'react'
import { Box } from '@material-ui/core'
import _ from 'lodash'
import { SORTORDER } from "../../utils/constants"

const EVENT_TYPE = {
  BATTERY_DISCHARGE: 'Discharge Event',
  BATTERY_CHARGE: 'Charge Event',
  IDLE: 'Idle Event'
}

const defaultSubType = {
  BATTERY_DISCHARGE: 'Discharge to Load and Grid',
  BATTERY_CHARGE: 'Charge From PV and Grid',
  IDLE: 'Idle'
}

const renderOptions = (programDetails) => {
  const featureFlags = _.get(programDetails, 'feature_flags', {})
  const isLoadBuildUp = _.get(featureFlags, 'load_build_up_event_type', false)

  if (isLoadBuildUp) {
    return [
      {
        label: 'Load Reduction',
        value: 'BATTERY_DISCHARGE'
      },
      {
        label: 'Load Build Up',
        value: 'BATTERY_CHARGE'
      }
    ]
  } else {
    return [
      {
        label: 'Load Reduction',
        value: 'BATTERY_DISCHARGE'
      }
    ]
  }


}

const eventForm = (programDetails) => {
  return [
    {
      id: "eventType",
      name: "eventType",
      label: "Event Type",
      type: 'custom',
    },
    {
      id: "eventSubType",
      name: "eventSubType",
      label: "Event Sub Type",
      type: 'custom',
    },
    {
      id: "startTime",
      name: "startTime",
      label: "Start Date and Time",
      type: "date"
    },
    {
      id: "endTime",
      name: "endTime",
      label: "End Date and Time",
      type: "date"
    },
    {
      id: "eventName",
      name: "eventName",
      label: "Event Name"
    },
    {
      id: "targetSoc",
      name: "targetSoc",
      label: "Target SoC (%)",
      icon: 'info',
      tooltipMsg: <Box>For an individual site, the event will end if the Battery SoC reaches the <b>{'Target SoC'}</b> before event end-time</Box>,
      hideFor: ['Idle Event']
    },
    {
      id: "scheduledPower",
      name: "scheduledPower",
      label: "Scheduled Power (kW)",
      hideFor: ['Idle Event']
    },   
  ]
}
const energyBasedEventForm = (programDetails) => {
  return [
    {
      id: "startTime",
      name: "startTime",
      label: "Start Date and Time",
      type: "date"
    },
    {
      id: "endTime",
      name: "endTime",
      label: "End Date and Time",
      type: "date"
    },
    {
      id: "eventName",
      name: "eventName",
      label: "Event Name"
    },
    {
      id: "targetSoc",
      name: "targetSoc",
      label: "Target SoC (%)",
      icon: 'info',
      tooltipMsg: <Box>For an individual site, the event will end if the Battery SoC reaches the <b>{'Target SoC'}</b> before event end-time</Box>,
      hideFor: ['Idle Event']
    },
    {
      id: "scheduledPower",
      name: "scheduledPower",
      label: "Scheduled Power (kW)",
      hideFor: ['Idle Event']
    },
    { 
      id: "scheduledEnergy",
      name: "scheduledEnergy",
      label: "Scheduled Energy (kWh)",
      hideFor: ['Idle Event']
    },
  ]
}

const tableHeadings = (classes) => (
  [
    {
      id: 'name',
      header: 'EVENT NAME',
      isActive: true,
      isLink: true,
      className: `${classes.tableHeading} ${classes.eventName}`
    },
    {
      id: 'type',
      header: 'EVENT TYPE',
      className: `${classes.tableHeading} ${classes.eventType}`
    },
    {
      id: 'sub_type',
      header: 'EVENT SUBTYPE',
      className: `${classes.tableHeading} ${classes.eventType}`
    },
    {
      id: 'start_date_time',
      header: 'START TIME',
      isSortable: true,
      sortOrder: SORTORDER.ASC,
      className: `${classes.tableHeading} ${classes.eventTime}`
    },
    {
      id: 'end_date_time',
      header: 'END TIME',
      isSortable: true,
      sortOrder: SORTORDER.DESC,
      className: `${classes.tableHeading} ${classes.eventTime}`
    },
    {
      id: 'duration',
      header: 'DURATION',
      className: `${classes.tableHeading} ${classes.eventTime}`
    },
    {
      id: 'systemsParticipated',
      header: 'SYSTEMS PARTICIPATED',
      className: `${classes.tableHeading}`
    }
  ]
)

const eventTypes = [
  {
    'name': 'Charge Event',
    'value': 'BATTERY_CHARGE',
    'description': 'Battery will charge either from PV or grid.',
    'filename': 'charge',
  },
  {
    'name': 'Discharge Event',
    'value': 'BATTERY_DISCHARGE',
    'description': 'Battery will discharge either to load or grid.',
    'filename': 'discharge'
  },
  {
    'name': 'Idle Event',
    'value': 'IDLE',
    'description': 'Battery will neither charge nor discharge.',
    'filename': 'idle'
  },
]

const eventTypeMapper = {
  'Charge Event': 'BATTERY_CHARGE',
  'Discharge Event': 'BATTERY_DISCHARGE',
  'Idle Event': 'IDLE'
}

const CHARGEFROMPV = 'Charge from PV'
const CHARGEFROMGRID = 'Charge from Net PV'
const CHARGEFROMPVANDGRID = 'Charge from PV and Grid'
const DISCHARGETOLOAD = 'Discharge to Load'
const DISCHARGETONETLOAD = 'Discharge to Net Load'
const DISCHARGETOLOADANDGRID = 'Discharge to Load and Grid'

const eventSubTypeMapper = {
  'Charge Event': [CHARGEFROMPV, CHARGEFROMGRID, CHARGEFROMPVANDGRID],
  'Discharge Event': [DISCHARGETOLOAD, DISCHARGETONETLOAD, DISCHARGETOLOADANDGRID],
  'Idle Event': []
}

const eventSubTypes = {
  [CHARGEFROMPV]: {
    value: 'Charge_From_PV',
    description: ['PV power is directed to battery.', 'Any remaining PV power is directed to the load.', 'Any remaining PV power is either curtailed (PEL Active) or exported to the grid.', 'Grid power is directed to satisfy any remaining load.']
  },
  [CHARGEFROMGRID]: {
    value: 'Charge_From_NetPV',
    description: ['PV power is directed to load.', 'Any remaining PV power is directed to the battery.', 'Any remaining PV power is either curtailed (PEL active) or exported to the grid.', 'Grid power is directed to satisfy any remaining load.']
  },
  [CHARGEFROMPVANDGRID]: {
    value: 'Charge_From_PV_Grid',
    description: ['PV power is directed to battery.', 'Any remaining PV power is directed to the load.', 'Any remaining PV power is either curtailed (PEL active) or exported to the grid.', 'Grid power is directed to satisfy any remaining Load and battery.']
  },
  [DISCHARGETOLOAD]: {
    value: 'Discharge_To_Load',
    description: ['Battery power is directed to the load.', 'Any remaining discharge capacity remains unused.', 'PV power is directed to satisfy any remaining load.', 'Any remaining PV either curtailed or exported to the grid.', 'Grid power is directed to satisfy any remaining load.']
  },
  [DISCHARGETONETLOAD]: {
    value: 'Discharge_To_NetLoad',
    description: ['PV power is directed to load.', 'Battery power is directed to net load (Load - PV).', 'Any remaining PV is either curtailed or exported to the grid.', 'Grid power is directed to satisfy any remaining load.']
  },
  [DISCHARGETOLOADANDGRID]: {
    value: 'Discharge_To_Load_Grid',
    description: ['PV Power is directed to load.', 'Any remaining PV is either curtailed or exported to the grid.', 'Battery power is directed to any remaining load.', 'Any remaining battery discharge capacity is exported to the grid.', 'Grid power is directed to satisfy any remaining load.']
  }
}

const CalendarFormat = 'MM-DD-YYYY hh:mm A'

export { eventForm, CalendarFormat, tableHeadings, EVENT_TYPE, eventTypes, eventSubTypes, eventSubTypeMapper, eventTypeMapper, defaultSubType, energyBasedEventForm }